import React from 'react';
import Table from 'react-bootstrap/Table';
import { FaDownload, FaFilter } from 'react-icons/fa';
import { reactLocalStorage } from 'reactjs-localstorage';

import ColdDataApi from '../../api/ColdDataApi';
import Util from '../../util/Util';
import withRouter from '../../util/WithRouter';
import Const from '../../util/Constants';
import ApiUiController from '../../controller/ApiUiController';
import ColdDataCallFilter from './ColdDataCallFilter';
import { CSVLink } from 'react-csv';

class ColdDataList extends React.Component {

  constructor(props) {
    super(props);
    this.lists = [];
    this.state = { inApiCall: true, showAddForm: false, showDeleteConfirm: false, deleteId: null, newName: '', newPhone: '', errors: {}, isFilterOpen: false, filters: [] };
    this.id = parseInt(props.match.params.id);
    this.path = this.props.match.path.replace(`/${this.id}`, '');
    
    this.models = reactLocalStorage.getObject(Const.Model) ;
    const model = this.models.cold_data;
    this.colddata = model; 

    this.options = this.models.call.fields.feedback.options;
    this.List = Util.isAllow(model.permission, Const.PermView);
  }

  componentDidMount() { 
    if(this.List) {
      this.loadModel(this.id, undefined);
    }
  }

  componentDidUpdate(prevProps) {
    const prevId = parseInt(prevProps.match.params.id);
    const currentId = parseInt(this.props.match.params.id);
    if (prevId !== currentId && this.List) {
      this.setState({ inApiCall: true });
      this.loadModel(currentId, undefined);
    }
  }

  loadModel = (id, filters) => {
    ColdDataApi.getUserDataList(id, filters, this.onReceived, this.onFail);
  }

  onFail = () => this.setState({ ...this.state, inApiCall: false });
  
  onReceived = imports => {
    
    this.lists = imports;
    this.setState({ inApiCall: false });
  }

  details = index => this.props.navigate(`${this.path}/data/${this.lists[index].id}`);

  addNumber = () => {
    const { newName, newPhone } = this.state;
    if (!newName || !newPhone) {
      return;
    }

    const coldDataUserId = this.lists.length > 0 ? this.lists[0].cold_data_user_id : null;
    const campaignId = this.lists.length > 0 ? this.lists[0].cold_data_id : null;
    
    if (!coldDataUserId || !campaignId) {
      return;
    }

    const contactData = {
      name: newName,
      phone_number: newPhone,
      campaignId,
      coldDataUserId
    };

    ColdDataApi.addContactToCampaign(
      contactData,
      (response) => {
        const newContact = {
          id: response.id,
          cold_data_user_id: coldDataUserId,
          cold_data_id: campaignId,
          name: newName,
          phone_number: newPhone,
          date_time: new Date().toISOString(),
          lead_generated: 0,
          feedback: null,
          duration: null,
          comment: null
        };

        this.lists = [newContact, ...this.lists];

        this.setState({ 
          showAddForm: false, 
          newName: '', 
          newPhone: '' 
        });
        Util.showNotification(
          "Successful",
          "Contact added successfully.",
          "success"
        );
      },
      (error) => {
        console.error('API Error:', error);
        Util.showNotification(
          "Error",
          "Failed to add contact: ",
          "danger"
        );
      }
    );
  };

  deleteNumber = () => {
    const id = this.state.deleteId;
    ColdDataApi.DeleteNumber(
      id, 
      () => {
        this.lists = this.lists.filter(item => item.id !== id);
        this.setState({ showDeleteConfirm: false, deleteId: null });
        Util.showNotification(
          "Successful",
          "Contact deleted successfully.",
          "success"
        );
      },
      () => {
        this.setState({ showDeleteConfirm: false, deleteId: null });
        Util.showNotification(
          "Error",
          "Failed to delete contact: ",
          "danger"
        );
      }
    );
  };

  time = secs => {
    let tmp = '';
    const hrs = Math.floor(secs / 3600);
    if(hrs > 0) { 
      secs -= hrs * 3600; 
      tmp = hrs + 'h';
    }

    const mins = Math.floor(secs / 60) % 60;
    if(mins > 0) {
      secs -= mins * 60;
      tmp += tmp !== '' ? ' ' + mins + 'm' : mins + 'm';
    }
    if(secs > 0) {
      tmp += tmp !== '' ? ' ' + secs + 's' : secs + 's';
    }
    return tmp !== '' ? `(${tmp})` : '(0s)';
  }

  onFilterChange = (data) => {
    this.setState({ filters: [...data] });
    this.loadModel(this.id, data);
  }

  toggleFilter = () => {
    // this.list.isFilterOpen = !this.state.isFilterOpen;
    // reactLocalStorage.setObject(Const.ListLead, this.list);
    this.setState({ isFilterOpen: !this.state.isFilterOpen });
  };

  closeFilter = () => this.setState({ isFilterOpen : false })

  getCsvData = () => {
    return this.lists.map((list, i) => ({
      'No'          : i + 1,
      'Date Time'   : Util.serverStringToDisplayDateTime(list.date_time),
      'Name'        : list.name,
      'Phone'       : list.phone_number,
      'Email'       : list.email,
      'Address'     : list.address,
      'Remark'      : list.remark,
      'Lead'        : list.lead_generated === 1 ? 'Yes' : 'No',
      'Feedback'    : this.options?.find(item => item.value === list?.feedback)?.label || '-',
      'Duration'    : list.duration ? this.time(list.duration) : '-',
      'Comment'     : list.comment,
    }));
  }

  render() {
    if(!this.List) return null;
    let importUI = this.lists.map((list, _i) => (
      <tr key={`import_${_i + 1}`}>
        <td>{_i + 1}</td>
        <td>{Util.serverStringToDisplayDateTime(list.date_time)}</td>
        <td>{list.name}</td>
        <td>{list.phone_number}</td>
        <td>{list.email}</td>
        <td>{list.address}</td>
        <td>{list.remark}</td>
        <td>{list.lead_generated === 1? 'Yes' : 'No'}</td>
        <td>{this.options?.find(item => item.value === list?.feedback)?.label || '-'}</td>
        <td>{list.duration ? this.time(list.duration) : '-'}</td>
        <td>{list.comment}</td>
        <td>
          {list.connected_status == null ? (
            <button 
              className="btn btn-danger btn-sm"
              onClick={() => this.setState({ showDeleteConfirm: true, deleteId: list.id })}
            >
              Remove
            </button>
          ) : null}
        </td>
      </tr>
    ));

    if(this.lists.length === 0) importUI = <tr><td colSpan="9">No Records Found</td></tr>;
    
    return (
      <div className="sectionlist pt-3">
        <div className="col-md-12">
          <div className="col-md-6 pb-3">
            <h3>Cold Data</h3>
          </div>
        </div>
        
        <div className="row pb-3 px-3">
          <div className='col-md-6'>
            <button
              className="btn btn-primary"
              onClick={() => this.setState({ showAddForm: true })}
            >
              + Add Number
            </button>
          </div>

          <div className="col-md-6 d-flex justify-content-end align-items-center gap-2">
            <CSVLink
              data={this.getCsvData()}
              filename={`cold-data-campaign-${this.id}.csv`}
              className="btn btn-success btn-sm"
            >
              <FaDownload /> Export CSV
            </CSVLink>

            <div className="btn btn-lead btn-sm filter-button" onClick={this.toggleFilter}>
              <FaFilter />
              <span className="badge badge-danger badge-mini rounded-circle">
                {this.state.filters.length}
              </span>
            </div>
          </div>
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className={`col-md-${this.state.isFilterOpen ? 9 : 12}`} >
              <div className='table-scroll table-responsive mb-5' style={{ scrollbarWidth: 'thin' }}>
                <Table striped bordered hover className="table-cursor">
                  <thead style={{width: "100%"}}>
                    <tr>
                      <th>No</th>
                      <th>Date Time</th>
                      <th>Name</th>
                      <th>Phone</th>
                      <th>Email</th>
                      <th>Address</th>
                      <th>Remark</th>
                      <th>Lead</th>
                      <th>Feedback</th>
                      <th>Duration</th>
                      <th>Comment</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody >
                    <ApiUiController inApiCall={this.state.inApiCall}>
                      { importUI }
                    </ApiUiController>
                  </tbody>
                </Table>  
              </div>
            </div>
            <ColdDataCallFilter
              filters={this.state.filters}
              onFilterChange={this.onFilterChange}
              closeFilter={this.closeFilter}
              isFilterOpen={this.state.isFilterOpen}
              feedbackOptions={this.options}
            />
            
            {/* Add Contact Modal */}
            {this.state.showAddForm && (
              <div 
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  background: "rgba(0,0,0,0.6)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  zIndex: 999,
                  backdropFilter: "blur(5px)"
                }}
              >
                <div 
                  style={{
                    background: "white",
                    padding: "25px",
                    borderRadius: "12px",
                    width: "400px",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
                    border: "none"
                  }}
                >
                  {/* Header */}
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="mb-0" style={{ color: "#2c3e50", fontWeight: "600", fontSize: "1.25rem" }}>
                      Add New Contact
                    </h5>
                    <button 
                      type="button" 
                      className="close" 
                      onClick={() => this.setState({ 
                        showAddForm: false, 
                        newName: '', 
                        newPhone: '', 
                        errors: {} 
                      })}
                      style={{ border: "none", background: "none", fontSize: "1.5rem", color: "#6c757d" }}
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>

                  {/* Form */}
                  <div className="mb-3">
                    <label className="form-label" style={{ color: "#495057", fontWeight: "500", fontSize: "0.9rem", marginBottom: "0.5rem" }}>
                      Name *
                    </label>
                    <input 
                      type="text" 
                      placeholder="Enter full name" 
                      className="form-control mb-1"
                      style={{ borderRadius: "8px", border: "1px solid #e0e0e0", padding: "10px 12px", fontSize: "0.95rem" }}
                      value={this.state.newName}
                      onChange={e => this.setState({ newName: e.target.value })}
                    />
                    {this.state.errors?.name && (
                      <div style={{ color: "red", fontSize: "0.8rem" }}>{this.state.errors.name}</div>
                    )}
                  </div>

                  <div className="mb-4">
                    <label className="form-label" style={{ color: "#495057", fontWeight: "500", fontSize: "0.9rem", marginBottom: "0.5rem" }}>
                      Phone Number *
                    </label>
                    <input 
                      type="text" 
                      placeholder="Enter 10-digit phone number" 
                      className="form-control mb-1"
                      style={{ borderRadius: "8px", border: "1px solid #e0e0e0", padding: "10px 12px", fontSize: "0.95rem" }}
                      value={this.state.newPhone}
                      onChange={e => this.setState({ newPhone: e.target.value.replace(/\D/g, '') })}
                      maxLength={10}
                    />
                    {this.state.errors?.phone && (
                      <div style={{ color: "red", fontSize: "0.8rem" }}>{this.state.errors.phone}</div>
                    )}
                  </div>

                  {/* Buttons */}
                  <div className="d-flex gap-2 justify-content-end">
                    <button 
                      className="btn btn-danger" 
                      onClick={() => this.setState({ showAddForm: false, newName: '', newPhone: '', errors: {} })}
                      style={{ borderRadius: "8px", padding: "8px 20px", fontWeight: "500" }}
                    >
                      Cancel
                    </button>
                    <button 
                      className="btn btn-primary" 
                      onClick={() => {
                        const { newName, newPhone } = this.state;
                        const errors = {};

                        if (!newName.trim()) errors.name = "Name is required";
                        if (!/^\d{10}$/.test(newPhone)) errors.phone = "Phone number must be exactly 10 digits";

                        if (Object.keys(errors).length > 0) {
                          this.setState({ errors });
                          return;
                        }

                        // Clear errors before adding
                        this.setState({ errors: {} }, this.addNumber);
                      }}
                      style={{ borderRadius: "8px", padding: "8px 24px", fontWeight: "500", background: "linear-gradient(135deg, #007bff, #0056b3)", border: "none" }}
                    >
                      Add Contact
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* Delete Confirmation Modal */}
            {this.state.showDeleteConfirm && (
              <div 
                style={{
                  position:"fixed",
                  top:0, left:0,
                  width:"100%",
                  height:"100%",
                  background:"rgba(0,0,0,0.5)",
                  display:"flex",
                  justifyContent:"center",
                  alignItems:"center",
                  zIndex:1000,
                  backdropFilter:"blur(4px)"
                }}
              >
                <div 
                  style={{
                    width:"380px",
                    background:"white",
                    borderRadius:"12px",
                    padding:"25px",
                    boxShadow:"0 8px 30px rgba(0,0,0,0.25)"
                  }}
                >
                  <h5 style={{ 
                    fontWeight:"600", 
                    color:"#dc3545",
                    marginBottom:"10px"
                  }}>
                    Are you sure?
                  </h5>

                  <p style={{ 
                    color:"#6c757d", 
                    fontSize:"0.95rem",
                    marginBottom:"20px" 
                  }}>
                    Do you really want to delete this contact? <br/>
                    <strong>This action cannot be undone.</strong>
                  </p>

                  <div className="d-flex justify-content-end gap-2">
                    <button 
                      className="btn btn-light"
                      style={{ borderRadius:"8px" }}
                      onClick={() => this.setState({ showDeleteConfirm:false })}
                    >
                      Cancel
                    </button>

                    <button 
                      className="btn btn-danger"
                      style={{ 
                        borderRadius:"8px",
                        padding:"8px 20px",
                        background:"linear-gradient(135deg, #dc3545, #b02a37)",
                        border:"none"
                      }}
                      onClick={this.deleteNumber}
                    >
                      Yes, Delete
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(ColdDataList);